import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from './sentry.client.config';
import Home from './app/page';

// Initialize Sentry before React app
initSentry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(<Home />);